export const EMPLOYMENT_STATUS = {
  EMPLOYED: 'Employed',
  SELF_EMPLOYED: 'Self-Employed',
  RETIRED: 'Retired',
  UNEMPLOYED: 'Unemployed',
  STUDENT: 'Student',
} as const

export type EmploymentStatus =
  (typeof EMPLOYMENT_STATUS)[keyof typeof EMPLOYMENT_STATUS]

export const EMPLOYMENT_STATUSES = [
  EMPLOYMENT_STATUS.EMPLOYED,
  EMPLOYMENT_STATUS.SELF_EMPLOYED,
  EMPLOYMENT_STATUS.RETIRED,
  EMPLOYMENT_STATUS.UNEMPLOYED,
  EMPLOYMENT_STATUS.STUDENT,
] as const satisfies readonly EmploymentStatus[]

export const EMPLOYMENT_STATUSES_WITH_OCCUPATION = [
  EMPLOYMENT_STATUS.EMPLOYED,
  EMPLOYMENT_STATUS.SELF_EMPLOYED,
] as const satisfies readonly EmploymentStatus[]

export const OCCUPATION = {
  OTHER: 'Other',
} as const

export function isEmploymentStatusValue(
  value: string
): value is EmploymentStatus {
  return (EMPLOYMENT_STATUSES as readonly string[]).includes(value)
}
